import React, { Fragment, useEffect } from "react";
import { Route, Switch, useHistory, useRouteMatch } from "react-router-dom";
import Profile from "../pages/Profile";
import ProfileForm from "../components/global/forms/ProfileForm";
import useFeatureFlags from "../services/utils/custom hooks/Feature Flagging/useFeatureFlags";
import dataConstants from "../constants/dataConstants";

function ProfilePageRoutes(): JSX.Element {
  const match = useRouteMatch();
  const { isSectionActive } = useFeatureFlags();
  const history = useHistory();

  useEffect(() => {
    if (!isSectionActive(dataConstants.FeatureFlagSectionKeys.USER_PROFILE)) {
      history.push("/unauthorized");
    }
  }, []);

  return (
    <Switch>
      <Route exact path={match.path} component={Profile} />
      <Route path={`${match.path}/editprofile`} component={ProfileForm} />
    </Switch>
  );
}

export default ProfilePageRoutes;
